import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card } from 'react-bootstrap';

function CandidateJobs() {
  return (
    <div className="w-100 d-flex justify-content-center py-12">
      <Card>
        <Card.Body>
          <div className="text-body-tertiary d-flex gap-4 align-items-center">
            <FontAwesomeIcon icon={faBriefcase} size="2x" />
            <span>
              Job opportunities matching your skills will be displayed here.
              <br />
              Stay updated and check back regularly to find the latest openings.
            </span>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default CandidateJobs;
